import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}booking/ski/rental/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  getSkiRentalsWithProductsByBookingId(bookingId) {
    return conduit.get(`booking/${bookingId}/with-products/all`);
  },

  /**
   * @param bookingId
   * @param bookingParticipantId
   * @param skiRentalProducts
   * @returns {AxiosPromise}
   */
  createSkiRentalWithProducts(bookingId, bookingParticipantId, skiRentalProducts) {
    return conduit.post(
      `booking/${bookingId}/participant/${bookingParticipantId}/create`,
      {
        skiRentalProducts,
      },
    );
  },

  /**
   * @param skiRentalProduct
   * @returns {AxiosPromise}
   */
  updateSkiRentalProduct(skiRentalProduct) {
    return conduit.put(
      `product/${skiRentalProduct.id}/update`,
      {
        skiRentalProduct,
      },
    );
  },

  /**
   * @param skiRentalProductPrice
   * @returns {AxiosPromise}
   */
  updateSkiRentalProductPrice(skiRentalProductPrice) {
    return conduit.put(
      `product/${skiRentalProductPrice.id}/update-price`,
      {
        skiRentalProductPrice,
      },
    );
  },

  /**
   * @param skiRental
   * @returns {AxiosPromise}
   */
  updateSkiRentalWithParticipantInfo(skiRental) {
    return conduit.put(
      'participant-info',
      {
        skiRental,
      },
    );
  },

  /**
   * @param skiRentalProductId
   * @param supplierRef
   * @returns {AxiosPromise}
   */
  updateSkiRentalProductWithSupplierRef(skiRentalProductId, supplierRef) {
    return conduit.put(
      `product/${skiRentalProductId}/supplier-ref`,
      {
        supplierRef,
      },
    );
  },

  /**
   * @param skiRentalProductId
   * @param status
   * @returns {AxiosPromise}
   */
  updateSkiRentalProductWithStatus(skiRentalProductId, status) {
    return conduit.put(
      `product/${skiRentalProductId}/status`,
      {
        status,
      },
    );
  },

  /**
   * @param skiRentalProductId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  cancelSkiRentalProduct(skiRentalProductId, salesAgentUserId) {
    return conduit.delete(
      `product/${skiRentalProductId}/sales-agent/${salesAgentUserId}/cancel`,
    );
  },

  /**
   * @param skiRentalProductId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  stopSkiRentalProduct(skiRentalProductId, salesAgentUserId) {
    return conduit.delete(
      `product/${skiRentalProductId}/sales-agent/${salesAgentUserId}/stop`,
    );
  },

  /**
   * @param skiRentalProductId
   * @param salesAgentUserId
   * @returns {AxiosPromise}
   */
  deleteSkiRentalProduct(skiRentalProductId, salesAgentUserId) {
    return conduit.delete(
      `product/${skiRentalProductId}/sales-agent/${salesAgentUserId}/delete`,
    );
  },

  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  sendSkiRentalRequestEmail(bookingId) {
    return conduit.post('send-supplier-request', { bookingId });
  },

  /**
   * @param skiRentalProductId
   * @param cancellationFeeNet
   * @returns {AxiosPromise}
   */
  updateSkiRentalCancellationFeeNet(skiRentalProductId, cancellationFeeNet) {
    return conduit.patch(`product/${skiRentalProductId}/cancellation-fee-net`, { cancellationFeeNet });
  },

  /**
   * @param skiRentalProductId
   * @returns {AxiosPromise}
   */
  reOpen(skiRentalProductId) {
    return conduit.patch(`product/${skiRentalProductId}/reopen`);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  assignParticipantToSkiPass(payload) {
    return conduit.patch('assign-participant', payload);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  bookByXML(payload) {
    return conduit.post('book-by-xml', { id: payload.id });
  },
};



// WEBPACK FOOTER //
// ./src/services/ski/booking-ski-rental-service.js